import { X } from 'lucide-react';
import { useDialogo } from '../lib/dialogo';

// La carcasa del diálogo: el mismo encabezado, el mismo sitio para
// cerrar y el mismo pie en los ocho diálogos que caben en ella. El
// comportamiento de teclado —Escape, encierro del foco, a dónde vuelve
// al cerrar— vive en `useDialogo`, que también usa el formulario de
// producto, cuya maquetación no cabe aquí.
export default function Modal({
  titulo,
  subtitulo,
  icono: Icono,
  derecha,
  ancho = 'max-w-md',
  onCerrar,
  bloqueado = false,     // en curso una operación: no se puede abandonar
  capa = true,           // ocupa una entrada del historial: «atrás» lo cierra
  guardia = true,        // si se escribió en un campo, «atrás» pregunta antes de cerrarlo
  children,
  pie,
}) {
  const { idTitulo, propsPanel } = useDialogo(onCerrar, { bloqueado, capa, guardia });

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* El fondo es decorativo: cerrar con clic fuera es un atajo de
          ratón que ya tiene su equivalente en la «X» y en Escape. Anunciarlo
          como un botón más solo alargaría el recorrido del lector. */}
      <div
        className="absolute inset-0 bg-black/40"
        aria-hidden="true"
        onClick={bloqueado ? undefined : onCerrar}
      />
      <div
        {...propsPanel}
        className={`relative w-full ${ancho} bg-white rounded-xl shadow-xl
                    max-h-full overflow-y-auto focus:outline-none`}
      >
        <div className="flex items-start justify-between gap-3 p-4 border-b border-gray-200">
          <div className="flex items-start gap-2.5 min-w-0">
            {Icono && <Icono className="h-5 w-5 text-gray-500 shrink-0 mt-0.5" aria-hidden="true" />}
            <div className="min-w-0">
              <h2 id={idTitulo} className="font-semibold text-gray-900">{titulo}</h2>
              {subtitulo && <p className="text-sm text-gray-500 mt-0.5">{subtitulo}</p>}
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            {derecha}
            <button
              type="button"
              onClick={onCerrar}
              disabled={bloqueado}
              // Sin esto el lector solo dice «botón». La etiqueta nombra
              // QUÉ se cierra, que es lo que hace falta cuando no se ve
              // la pantalla.
              aria-label={`Cerrar ${titulo}`}
              className="text-gray-500 hover:text-gray-900 disabled:opacity-40 rounded
                         focus:outline-none focus:ring-2 focus:ring-[var(--color-marca)] focus:ring-offset-1"
            >
              <X className="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
        </div>

        <div className="p-4">{children}</div>
        {pie}
      </div>
    </div>
  );
}
